<template>
<md-card>
    <header-form title="EDITAR SEGUIMENTO" :rota="{name: 'seguimentosRead'}" tooltip="Lista Seguimentos" />

      <form @submit.prevent="update">
        <md-card-content>
            <div class="md-layout">
                <div class="md-layout-item md-size-40 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.nome }">
                        <label>NOME</label>
                        <md-input v-model="dados.nome" type="text"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.nome">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.nome" class="validErro"> {{ errors.nome[0] }}</div>
                </div>

                <div class="md-layout-item md-size-60 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.observacao }">
                        <label>OBSERVAÇÃO</label>
                        <md-input v-model="dados.observacao" type="text"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.observacao">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.observacao" class="validErro"> {{ errors.observacao[0] }}</div>
                </div>
            </div>
        </md-card-content>

        <md-card-actions>
            <md-button type="submit" class="md-success md-round">
                <span class="md-label">
                    <md-icon class="material-icons">check</md-icon>
                </span>SALVAR
            </md-button>
        </md-card-actions>
    </form>

</md-card>
</template>

<script>
import Notify from '@/config/mixins/notify'
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'

export default {
    components: {
        HeaderForm
    },
    data() {
        return {
            dados: {},
            errors: {}
        }
    },

    created() {
        this.getSeguimento()
    },

    mixins: [Notify],

    methods: {

        getSeguimento() {
            this.$http.get(this.$urlAPI + 'seguimentos/' + this.$route.params.id)
                .then(response => {
                    if (response.data.status) {
                        this.dados = response.data.dados;
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        update() {
            this.$http.put(this.$urlAPI + 'seguimentos/' + this.dados.id, this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.$router.push({
                            name: 'seguimentosRead'
                        });
                        this.success(response.data.message)
                        this.errors = ''
                    } else if (response.data.errors) {
                        this.errors = response.data.errors
                    } else {
                        this.danger(response.data.message)
                        this.errors = ''
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },
    }
};
</script>
